<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 15:24:04
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-04 15:22:04
-->
<template>
  <el-dialog
    title="商品同步"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
  >
    <div class="flex-column flex-align-center">
      <template v-if="isLoading">
        <el-progress
          type="circle"
          :percentage="progressRadio"
          :stroke-width="8"
          color="#2475FF"
          :width="80"
          stroke-linecap="butt"
        ></el-progress>
        <p class="yx-color-text-primary fz-14 mt-12">{{ errMsg }}</p>
      </template>
      <el-result icon="error" :title="errMsg" v-else-if="isError"></el-result>
      <el-result icon="success" title="已完成商品同步" v-else></el-result>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="fz-12 yx-color-text-secondary mr-12" v-if="isLoading"
        >关闭弹窗不影响同步进度</span
      >
      <el-button @click="visible = false">关闭</el-button>
      <el-button type="primary" @click="reAsync" v-if="isError"
        >重新同步</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  ASYNC_PENDING_STATUS,
  ASYNC_SUCCESS_STATUS,
  ASYNC_FAIL_STATUS,
} from "@/utils/dataMap";
export default {
  name: "AsyncDialog",
  props: {
    sourceData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    status() {
      return this.sourceData.result_code;
    },
    ratio() {
      return this.sourceData?.ratio || 0;
    },
    progressRadio() {
      return this.ratio ? Math.round(this.ratio * 10000) / 100 : 0;
    },
    errMsg() {
      return this.sourceData?.result_msg || "";
    },
    isLoading() {
      return this.status === ASYNC_PENDING_STATUS;
    },
    isError() {
      return this.status === ASYNC_FAIL_STATUS;
    },
    isSuccess() {
      return this.status === ASYNC_SUCCESS_STATUS;
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    reAsync() {
      this.$emit("reAsync");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-progress__text {
  color: @color-primary;
  font-family: DINAlternate-Bold, DINAlternate;
  font-size: 18px !important;
}
/deep/.el-result {
  padding-top: 16px;
  padding-bottom: 16px;
  p {
    font-size: 14px;
  }
}
/deep/.el-progress-circle__track {
  stroke: fadeout(@color-primary, 90%);
}
</style>